import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	OnDestroy,
	OnInit,
	ViewChild,
} from '@angular/core';
import { DynamicContentService, DynamicContentTargets, WithDynamicContent } from '@woolworthsnz/dynamic-content';
import { BreadcrumbComponent, RecipeBreadcrumbService } from '@woolworthsnz/recipe';
import { WithPageMeta, EmbeddedVisibilityDirective } from '@woolworthsnz/styleguide';

@WithPageMeta({ pageTitle: 'recipeLanding', metaTitle: 'recipeLanding', metaDescription: 'recipeLanding' })
@WithDynamicContent({ target: '/shop/recipes', dynamicContentTarget: DynamicContentTargets.dynamicContentPanel })
@Component({
	selector: 'wnz-recipes',
	template: `
		<recipe-breadcrumb *cdxEmbedded="'hide'"></recipe-breadcrumb>
		<div id="dynamic-content-panel" #dynamicContentPanel class="dynamic-content-canvas"></div>
	`,
	styleUrls: ['./recipes.page.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [EmbeddedVisibilityDirective, BreadcrumbComponent],
})
export class RecipesPage implements AfterViewInit, OnDestroy, OnInit {
	@ViewChild('dynamicContentPanel', { read: ElementRef }) dynamicContentPanel: ElementRef;

	constructor(
		private dynamicContentService: DynamicContentService,
		private breadcrumbService: RecipeBreadcrumbService
	) {}

	ngOnInit(): void {
		this.breadcrumbService.setBreadcrumbs();
	}

	ngAfterViewInit(): void {
		this.dynamicContentService.setViewChildForOutlet(
			this.dynamicContentPanel,
			DynamicContentTargets.dynamicContentPanel
		);
	}

	ngOnDestroy(): void {
		this.dynamicContentService.clearViewChildForOutlet(DynamicContentTargets.dynamicContentPanel);
	}
}
